import React from 'react';
import { FormattedHTMLMessage } from 'react-intl';
import {
    VerificationService,
    closeTabRef,
    SuccessResponse,
    FormFooterComponent,
} from '@sheerid/jslib';

import { getQueryParamsByName } from '../../lib/utils/browser';
import { SUCCESS_LINK_ONE } from '../../constants';

interface StepSuccessProps {
    verificationService: VerificationService;
}

const StepSuccessComponent = ({ verificationService }: StepSuccessProps) => {
    // Close any open tab for SSO login
    closeTabRef();

    const rewardCode = (verificationService.verificationResponse as SuccessResponse).rewardCode || '${rewardCode}';

    return (
        <div id="sid-step-success" className="sid-l-container">
            <div className="sid-header sid-l-horz-center sid-l-space-top-md">
                <div className="sid-header__title sid-l-space-top-md">
                    <FormattedHTMLMessage id="step.success.title" defaultMessage="Success! You've been verified." />
                </div>
                <div className="sid-header__subtitle">
                    <FormattedHTMLMessage id="step.success.subtitle" defaultMessage={
                        `Here is your personal coupon code.
                        It is unique to you and can only be used once.`
                    } />
                </div>
            </div>

            <div className="sid-reward-code sid-l-space-top-lg sid-h-jumbo-text">
                {rewardCode}
            </div>

            <div className="sid-under-coupon-code">
                <FormattedHTMLMessage
                    id="step.success.underCoupon"
                    defaultMessage="Please use this code for all exclusive offers below."
                />
            </div>

            <div className="sid-form-region sid-submit-wrapper sid-l-space-top-md">
                <button
                    onClick={() => window.open(SUCCESS_LINK_ONE, '_blank')}
                    type="submit"
                    className={'sid-btn sid-btn--dark sid-l-full-width sid-btn-round'}
                    aria-label="submit"
                >
                    <FormattedHTMLMessage id="step.success.buttonTwo" defaultMessage="Get Started" />
                </button>
            </div>

            <div className="sid-redirect-text sid-l-space-top-lg sid-pre-footer">
                <FormattedHTMLMessage
                    id="step.success.redirectTextA"
                    defaultMessage="To make sure you have every opportunity to use your discount, we're also emailing you a copy of your code and a link to the P.volve website so that you can shop now, or shop later. Please check for an email from us (verify@sheerid.com) for all the details."
                />
            </div>

            <div className="sid-redirect-text sid-l-space-top-md sid-pre-footer">
                <FormattedHTMLMessage
                    id="step.success.redirectTextB"
                    defaultMessage='Already an existing streaming member? Head to your account settings page, click "subscription" and apply your promo code. The updated membership will be applied at your next billing cycle.'
                />
            </div>

            <div className="sid-footer sid-l-space-top-md sid-h-small-text">
                <FormFooterComponent verificationService={verificationService} />
            </div>
        </div>
    );
};

export { StepSuccessComponent };
